import { useTrack as useGenericTrack } from "@fideus/analytics";
import type { Event } from "./events/Event";

export const useTrack = useGenericTrack<Event>;
